export type Side = "front" | "back";

export interface IFileData {
    id: string;
    name: string;
    size: number;
    type: string;
    data: ArrayBuffer;
    base64: string | null;
    width: number | null;
    height: number | null;
    side?: Side;
}

export function fileToData(file: File): Promise<IFileData> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
            if (!(reader.result instanceof ArrayBuffer)) {
                reject(new Error("Error reading file"));
                return;
            }

            const buffer = reader.result;

            if (file.type.startsWith("image/")) {
                const imgReader = new FileReader();
                imgReader.onload = () => {
                    const base64 = imgReader.result as string;
                    const img = new Image();
                    img.onload = () => {
                        resolve({
                            id: crypto.randomUUID(),
                            name: file.name,
                            size: file.size,
                            type: file.type,
                            data: buffer,
                            base64,
                            width: img.width,
                            height: img.height,
                        });
                    };
                    img.onerror = () => reject(new Error("Error loading image"));
                    img.src = base64;
                };
                imgReader.readAsDataURL(file);
            } else {
                resolve({
                    id: crypto.randomUUID(),
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    data: buffer,
                    base64: null,
                    width: null,
                    height: null,
                });
            }
        };

        reader.onerror = () => reject(reader.error);
        reader.readAsArrayBuffer(file);
    });
}

export async function convertFiles(files: FileList): Promise<IFileData[]> {
    if (!files || files.length === 0) return;

    const fileArray = Array.from(files);
    return await Promise.all(fileArray.map((file) => fileToData(file)));
}
